module.exports = __webpack_public_path__ + "assets/c000b1d5b12413c268a3f9cc95e9a092.json";